// package: proto.paint
// file: paint.proto

let paint_pb = require("./paint_pb");
let grpc = require("@improbable-eng/grpc-web").grpc;

let TerrainPaintingService = (function () {
  function TerrainPaintingService() { }
  TerrainPaintingService.serviceName = "proto.paint.TerrainPaintingService";
  return TerrainPaintingService;
}());

TerrainPaintingService.Paint = {
  methodName: "Paint",
  service: TerrainPaintingService,
  requestStream: false,
  responseStream: false,
  requestType: paint_pb.PaintRequest,
  responseType: paint_pb.PaintResponse
};

TerrainPaintingService.PaintThemAll = {
  methodName: "PaintThemAll",
  service: TerrainPaintingService,
  requestStream: false,
  responseStream: false,
  requestType: paint_pb.PaintMultipleRequest,
  responseType: paint_pb.PaintResponse
};

TerrainPaintingService.Erase = {
  methodName: "Erase",
  service: TerrainPaintingService,
  requestStream: false,
  responseStream: false,
  requestType: paint_pb.EraseRequest,
  responseType: paint_pb.EraseResponse
};

TerrainPaintingService.PaintCells = {
  methodName: "PaintCells",
  service: TerrainPaintingService,
  requestStream: false,
  responseStream: false,
  requestType: paint_pb.PaintCellsRequest,
  responseType: paint_pb.PaintResponse
};

exports.TerrainPaintingService = TerrainPaintingService;

function TerrainPaintingServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

TerrainPaintingServiceClient.prototype.paint = function paint(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  let client = grpc.unary(TerrainPaintingService.Paint, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          let err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TerrainPaintingServiceClient.prototype.paintThemAll = function paintThemAll(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  let client = grpc.unary(TerrainPaintingService.PaintThemAll, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          let err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TerrainPaintingServiceClient.prototype.erase = function erase(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  let client = grpc.unary(TerrainPaintingService.Erase, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          let err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TerrainPaintingServiceClient.prototype.paintCells = function paintCells(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  let client = grpc.unary(TerrainPaintingService.PaintCells, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          let err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.TerrainPaintingServiceClient = TerrainPaintingServiceClient;

